import React, { memo } from 'react';

import PropTypes from 'prop-types';

import * as utils from '../../shared/utils';
import { MILLIS_PER_SECOND } from '../../helpers/assets/durationSecondsToMillis';

function Duration(props) {
  const { duration } = props;
  const normalizedDuration = utils.parseTime(duration / MILLIS_PER_SECOND);

  return <div className="catalogItem__duration">{normalizedDuration}</div>;
}

Duration.propTypes = {
  duration: PropTypes.number.isRequired,
};

export default memo(Duration);
